<template>
  <x-form
    :title="$t('Disabilitare autenticazione a due fattori?')"
    variant="small"
    modal
    open
    @update:open="$emit('update:open', $event)"
    @cancel="$emit('update:enabled', true)"
    @submit="disable"
  >
    <template #description>
      {{ $t("Questo ridurrà la sicurezza del tuo account. Sei sicuro di voler disabilitare l'autenticazione a 2 fattori?") }}
    </template>

    <form-group :name="$t('Conferma codice di authenticazione a due fattori')">
      <x-input id="twoFAVerifyCode" v-model="verifyCode" required />
    </form-group>
  </x-form>
</template>

<script lang="ts" setup>
import { http } from '@/http';
import { $t as _t } from '@/i18n';
import { ref } from 'vue';
import type { ComponentProps } from 'vue-component-type-helpers';
import type XForm from './x-form.vue';

type XFormProps = ComponentProps<typeof XForm>;

interface Props extends /* @vue-ignore */ Omit<XFormProps, 'variant' | 'title'> {
  enabled?: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'update:open', value: boolean): void;
  (e: 'update:enabled', value: boolean): void;
}>();

const verifyCode = ref('');

async function disable() {
  const data = new FormData();
  data.append('totp', verifyCode.value);
  const response = await http.post('/api/auth/disabletotp', data);
  if (response.data.level === 'success') {
    emit('update:open', false);
    emit('update:enabled', false);
  }
}
</script>
